import Button from './Button';
import { ExternalLink } from '@app/components/Links';

const ExternalLinkButton = Button.withComponent(ExternalLink);

export default ExternalLinkButton;
